import React from 'react'
import {Typography, Box} from '@mui/material'
export const TotalImport = ({totalImporte}) => {

    
  return (
    <Box
        display="flex"
        alignItems="center"
        sx={{
            backgroundColor: '#f5f5f5',
            padding: '4px 12px',
            borderRadius: '4px',
        }}
    >
        <Typography
            sx={{ fontSize: '12px', fontWeight: 'bold', marginRight: '8px' }}
        >
        Importe Total:
        </Typography>
        <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
            {(totalImporte)} €
        </Typography>
    </Box>
  )
}
